import { render } from "./CalculatorPopup.vue?vue&type=template&id=72f01506&scoped=true"
import script from "./CalculatorPopup.vue?vue&type=script&lang=js"
export * from "./CalculatorPopup.vue?vue&type=script&lang=js"

import "./CalculatorPopup.vue?vue&type=style&index=0&id=72f01506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f01506"]])

export default __exports__